<template>
    <div class="relatorio-wrapper">
        <div class="d-flex justify-content-center align-items-center mb-4 steps-container ignore-print">
            <div class="step-item active">
                <span class="step-dot"></span>
                <span class="step-label">Pré-visualização de impressão</span>
            </div>
            <div class="step-line"></div>
            <div class="step-item text-muted">
                <span class="step-dot gray"></span>
                <span class="step-label">Upload de arquivo Assinado</span>
            </div>
        </div>

        <div class="paper-preview">
            <div class="paper-header d-flex justify-content-between align-items-center mb-4">
                <div class="logo-box">
                    <h4 class="text-primary weight-600"><i class="fa fa-sun-o"></i> SUAPE</h4>
                </div>

                <div class="doc-title text-center">
                    <h5 class="weight-600 text-uppercase mb-0">Cronograma Físico-Financeiro</h5>
                </div>

                <div class="logo-box text-right">
                    <h5 class="text-secondary weight-600">{{ contrato.contratada }}</h5>
                </div>
            </div>

            <resumo-contratual
                :contrato="contrato"
                :boletim-medicao="boletimMedicao"
            ></resumo-contratual>
            <div class="table-print-wrapper mt-4">
                <boletim-medicao-cronograma-table
                    :lista-itens="itens"
                    :dados-total="total"
                    :indice-fixo-bm="indiceFixoBm"
                ></boletim-medicao-cronograma-table>
            </div>
        </div>
    </div>
</template>

<script>
import BoletimMedicaoCronogramaTable from './BoletimMedicaoCronogramaTable.vue'
import ResumoContratual from '../../ResumoContratual.vue'

export default {
    name: 'RelatorioParaExportacao',
    components: {
        BoletimMedicaoCronogramaTable,
        ResumoContratual
    },
    props: {
        contrato: { type: Object, required: true },
        boletimMedicao: { type: Object, required: true },
        itens: { type: Array, default: () => [] },
        total: { type: Object, required: true },
        indiceFixoBm: { type: [String, Number], default: 0 }
    }
}
</script>

<style scoped>
.relatorio-wrapper { width: 100%; }

/* STEPS */
.steps-container { margin-bottom: 20px; }
.step-item { display: flex; align-items: center; font-weight: 600; color: #007bff; font-size: 0.9rem; }
.step-item.text-muted { color: #6c757d; }
.step-dot { width: 12px; height: 12px; background-color: #007bff; border-radius: 50%; margin-right: 8px; }
.step-dot.gray { background-color: #dee2e6; }
.step-line { width: 60px; height: 2px; background-color: #007bff; margin: 0 15px; }

/* Weight utility */
.weight-600 { font-weight: 600 !important; }

/* PAPEL A4 PREVIEW */
.paper-preview {
    background-color: #fff;
    border: 1px solid #dee2e6;
    padding: 30px;
    max-width: 100%;
}

/* ESTILOS DE IMPRESSÃO */
@media print {
    @page { margin: 10mm; size: landscape; }
    body { background-color: #fff; }
    .relatorio-wrapper { width: 100%; margin: 0; padding: 0; }
    .paper-preview { border: none; padding: 0; margin: 0; width: 100%; }
    .ignore-print { display: none !important; }
}
</style>
